import React, { Component, Fragment } from 'react';
import OpenAlerts from './OpenAlerts';
import PlayerRegistration from './PlayerRegistration';
import StatsNumbers from './StatsNumbers';
import GeographicalInsight from './GeographicalInsight';
import OverallRisk from './OverallRisk';
import TopRiskyPlayers from './TopRiskyPlayers';
import { fetchStats } from '../redux/actions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import tooltip from '../../../../shared/tooltip/tooltip.json';
import './DashboardContentContainer.scss';
import {
    getNumberOfActivePlayers,
    getNumberOfBetsForTheLastDay,
    getNumberOfDepositsForTheLastDay,
    getNumberOfPlayers,
    getNumberOfPlayersWithOpenAlerts,
    getNumberOfWithdrawalsForTheLastDay,
    getOpenAlertsPerRuleCategory,
    getOverallSystemRisk,
    getRegistrationsPerMonth,
    getTopRiskyPlayers
} from '../redux/selectors';
import { ContentBox } from '../../../../shared/content-box/ContentBox';
import { SandboxNote } from '../../../../shared/sandbox/SandboxNote';
import { isSandboxSelected } from '../../../../jurisdiction/redux/selectors';
import * as _ from 'lodash';

export const sandboxMapNote =
    'The world map shows the traffic and alerts of production jurisdictions. A sandbox is never on it, so it is left out here.';
export const sandboxTrendsNote =
    'Sandbox shows activity from now on. There is no history before its first run, so what is compared with last week, and the registrations per month, start from nothing.';
export const sandboxNoRegistrationsNote =
    'Sandbox shows activity from now on. No simulated player has registered in it yet.';

/* Whether the registrations per month hold a registration at all: a chart of nothing but zeros looks like a fault. */
export const hasRegistrations = registrationsPerMonth =>
    _.sumBy(registrationsPerMonth, 'registrations') > 0;

class DashboardContentContainer extends Component {
    statsInterval;

    constructor(props) {
        super(props);
        this.state = {
            openAlerts: [],
            registrationsPerMonth: [],
            isLoaded: false,
            error: '', // todo [mandy] make use of error later on
            activeCharts: {
                wagersStatistics: true,
                siteTraffic: true,
                geographicalInsight: true,
                recentPlayerAlerts: true,
                implicatedPlayers: true
            }
        };
    }

    componentDidMount() {
        this.props.fetchStats(false);
        this.statsInterval = this.fetchStatsInterval();
        this.turnOffChart('siteTraffic');
    }

    componentWillUnmount() {
        // console.log("Closing interval");
        clearInterval(this.statsInterval);
    }

    fetchStatsInterval = () =>
        setInterval(
            () => this.props.fetchStats(false),
            this.props.loadDataFrequencyInSec * 10000
        );

    turnOffChart(chartSectionName) {
        this.setState({ activeCharts: { [chartSectionName]: false } });
    }

    // todo the skeleton
    // todo 4 draggable components which take the whole width of the page, but are of varying sizes
    // todo each draggable component can have multiple blocks containing different information in it.

    render() {
        const { sandboxSelected } = this.props;

        return (
            <Fragment>
                {/*<OpenAlerts data={this.state.openAlerts}/>*/}
                {/*<PlayerRegistration data={this.state.registrationsPerMonth}/>*/}

                {sandboxSelected ? (
                    // The server leaves the sandboxes out of the map and of its figures, so it would show a country with nothing in it
                    <SandboxNote>{sandboxMapNote}</SandboxNote>
                ) : (
                    <GeographicalInsight
                        trafficTooltipMessage={tooltip.dashboard.trafficPerHour}
                        alertsTooltipMessage={tooltip.dashboard.alertsPerHour}
                    />
                )}
                {sandboxSelected && (
                    <SandboxNote>{sandboxTrendsNote}</SandboxNote>
                )}
                <StatsNumbers
                    data={this.props.numberStats}
                    sandbox={sandboxSelected}
                />
                <div className="row-content">
                    <ContentBox
                        size="l"
                        title="Player Registrations"
                        content={
                            sandboxSelected &&
                            !hasRegistrations(
                                this.props.registrationsPerMonth
                            ) ? (
                                <SandboxNote>
                                    {sandboxNoRegistrationsNote}
                                </SandboxNote>
                            ) : (
                                <PlayerRegistration
                                    data={this.props.registrationsPerMonth}
                                />
                            )
                        }
                        style={{ flex: '60%' }}
                        tooltipMessage={tooltip.dashboard.playerRegistrations}
                    />
                    {this.props.openAlerts.loaded && (
                        <ContentBox
                            size="l"
                            title="Anti Money Laundering Open Alerts"
                            content={
                                <OpenAlerts data={this.props.openAlerts.data} />
                            }
                            style={{ flex: '40%' }}
                            tooltipMessage={tooltip.dashboard.alertsPerRule}
                        />
                    )}
                </div>
                <div className="row-content">
                    {this.props.overallSystemRisk.loaded && (
                        <ContentBox
                            size="xl"
                            title="Overall Risk"
                            content={
                                <OverallRisk
                                    riskLevel={
                                        this.props.overallSystemRisk.data
                                            .overallRisk
                                    }
                                />
                            }
                            style={{ flex: '20%' }}
                            tooltipMessage={tooltip.dashboard.overallRisk}
                        />
                    )}
                    <ContentBox
                        size="xl"
                        title="Top Risky Players"
                        content={
                            <TopRiskyPlayers
                                riskyPlayers={this.props.topRiskyPlayers}
                            />
                        }
                        style={{ flex: '60%' }}
                        tooltipMessage={tooltip.dashboard.topRiskPlayers}
                    />
                    {/*<ContentBox title='Alerts Stats' content={<AlertsStats/>} style={{flex: '1'}}/>*/}
                    {/*<ContentBox title='New Players' subtitle='View All ->' style={{flex: '1'}}/>*/}
                </div>
            </Fragment>
        );
    }
}
const mapStateToProps = store => {
    return {
        openAlerts: getOpenAlertsPerRuleCategory(store),
        registrationsPerMonth: getRegistrationsPerMonth(store),
        numberStats: {
            numberOfDepositsForTheLastDay: getNumberOfDepositsForTheLastDay(
                store
            ),
            numberOfWithdrawalsForTheLastDay: getNumberOfWithdrawalsForTheLastDay(
                store
            ),
            numberOfBetsForTheLastDay: getNumberOfBetsForTheLastDay(store),
            numberOfActivePlayersForTheLastDay: getNumberOfActivePlayers(store),
            numberOfPlayersWithOpenAlerts: getNumberOfPlayersWithOpenAlerts(
                store
            ),
            totalNumberOfPlayers: getNumberOfPlayers(store)
        },
        overallSystemRisk: getOverallSystemRisk(store),
        topRiskyPlayers: getTopRiskyPlayers(store),
        sandboxSelected: isSandboxSelected(store)
    };
};

const mapDispatchToProps = dispatch => ({
    fetchStats: clearOldStats => dispatch(fetchStats({ clearOldStats }))
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(DashboardContentContainer)
);
